export default __webpack_public_path__ + "static/media/13C.099fa28d.webp";